import axiosBearerClient from './axiosBearerClient';
import { useQuery } from '@tanstack/react-query';

export const useUploadMeterPictures = (
	referenceCode?: string,
	pictures?: FormData
) => {
	const { isFetching, error, data, isError, refetch } = useQuery({
		queryKey: ['useUploadMeterPictures', referenceCode, pictures],
		enabled: false,
		retry: false,
		queryFn: async ({ queryKey }) => {
			return await axiosBearerClient.post(
				`/mro/pictures/${queryKey[1]}`,
				queryKey[2],
				{
					headers: { 'Content-Type': 'multipart/form-data' },
				}
			);
		},
	});

	return {
		isFetching,
		error,
		isError,
		data,
		refetch,
	};
};
